import { NoImage } from '../assets/icons';

export const getImageUrl = (_dir,filename) => {
  if (!filename) return NoImage;
  try {
    return require(`../assets/${_dir}/${filename}`);
  } catch (error) {
    console.error(`Could not find image: ${filename}`, error);
    return NoImage;
  }
}